import { render, staticRenderFns } from "./SalaryExpectations.vue?vue&type=template&id=b740a442"
import script from "./SalaryExpectations.vue?vue&type=script&lang=js"
export * from "./SalaryExpectations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports